import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { LangProvider } from "./lib/i18n";
import { Loading } from "./components/common";
import AdminLayout from "./components/AdminLayout";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import StaffLogin from "./pages/StaffLogin";
import Station from "./pages/Station";
import MonitorPortal from "./pages/MonitorPortal";
import LiveScreen from "./pages/LiveScreen";
import Dashboard from "./pages/admin/Dashboard";
import Meetings from "./pages/admin/Meetings";
import MeetingForm from "./pages/admin/MeetingForm";
import MeetingDetail from "./pages/admin/MeetingDetail";
import Participants from "./pages/admin/Participants";
import GkkDirectory from "./pages/admin/GkkDirectory";
import Ministries from "./pages/admin/Ministries";
import Monitors from "./pages/admin/Monitors";
import Devices from "./pages/admin/Devices";
import Stats from "./pages/admin/Stats";
import Reports from "./pages/admin/Reports";
import Audit from "./pages/admin/Audit";
import SettingsPage from "./pages/admin/Settings";
import Corrections from "./pages/admin/Corrections";
import Records from "./pages/admin/Records";
import RsvpLink from "./pages/RsvpLink";
import { ParishSiteBadge } from "./components/ParishSiteBadge";

function Guard({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to={user.role === "monitor" ? "/monitor" : "/admin"} replace />;
  return children;
}

const A = (el) => <Guard roles={["admin"]}>{el}</Guard>;

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/m/:mid" element={<Register />} />
            <Route path="/rsvp/:token" element={<RsvpLink />} />
            <Route path="/me" element={<Profile />} />
            <Route path="/login" element={<StaffLogin />} />
            <Route path="/station" element={<Station />} />
            <Route path="/monitor" element={<Guard roles={["monitor"]}><MonitorPortal /></Guard>} />
            <Route path="/monitor/:mid" element={<Guard roles={["monitor"]}><MonitorPortal /></Guard>} />
            <Route path="/live/:mid" element={<Guard roles={["admin", "officer", "monitor"]}><LiveScreen /></Guard>} />
            <Route path="/admin" element={<Guard roles={["admin", "officer"]}><AdminLayout /></Guard>}>
              <Route index element={<Dashboard />} />
              <Route path="meetings" element={<Meetings />} />
              <Route path="meetings/new" element={A(<MeetingForm />)} />
              <Route path="meetings/:mid/edit" element={A(<MeetingForm />)} />
              <Route path="meetings/:mid" element={<MeetingDetail />} />
              <Route path="participants" element={<Participants />} />
              <Route path="gkk" element={A(<GkkDirectory />)} />
              <Route path="ministries" element={A(<Ministries />)} />
              <Route path="monitors" element={A(<Monitors />)} />
              <Route path="devices" element={A(<Devices />)} />
              <Route path="corrections" element={A(<Corrections />)} />
              <Route path="stats" element={<Stats />} />
              <Route path="reports" element={<Reports />} />
              <Route path="records" element={<Records />} />
              <Route path="audit" element={A(<Audit />)} />
              <Route path="settings" element={A(<SettingsPage />)} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <ParishSiteBadge />
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </LangProvider>
  );
}
